import { createSlice } from '@reduxjs/toolkit'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'

const { SOCKET_STATUS } = INTERNAL_CONSTANTS

const initialState = {
  status: SOCKET_STATUS.DISCONNECTED, // 'DISCONNECTED' | 'CONNECTING' | 'CONNECTED' | 'RECONNECTING' | 'ERROR'
  connectedAt: null, // epoch ms of the last successful connect
  socketId: null,
  lastError: null,
}

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    setSocketConnecting: (state) => {
      state.status = SOCKET_STATUS.CONNECTING
      state.lastError = null
    },
    setSocketConnected: (state, action) => {
      state.status = SOCKET_STATUS.CONNECTED
      state.socketId = action.payload?.socketId ?? null
      state.connectedAt = action.payload?.connectedAt ?? null
      state.lastError = null
    },
    setSocketReconnecting: (state) => {
      state.status = SOCKET_STATUS.RECONNECTING
    },
    setSocketDisconnected: (state, action) => {
      state.status = SOCKET_STATUS.DISCONNECTED
      state.socketId = null
      state.connectedAt = null
      state.lastError = action.payload?.reason ?? null
    },
    setSocketError: (state, action) => {
      state.status = SOCKET_STATUS.ERROR
      state.lastError = action.payload?.error ?? null
    },
    resetSocket: () => initialState,
  },
})

export const {
  setSocketConnecting,
  setSocketConnected,
  setSocketReconnecting,
  setSocketDisconnected,
  setSocketError,
  resetSocket,
} = socketSlice.actions

export default socketSlice.reducer
